<template>
  <div>
    <!-- <img src="../../../assets/img/fullScreen.png" class="fullScreen" @click="toFull" alt=""> -->
    <div class="container season2 group1">
      <div class="screen">
        <div class="page">
          <!-- <img class="qr" @click="toFull" :src="'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/' + (districtId === '9' ? 'left-photo-huabei' : 'left-photo') + '.jpg'" alt=""> -->
          <img class="qr" @click="toFull" :src="'https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/left-wechat.jpg'" alt="">
          <div class="content">
            <div class="left">
              <div class="title">
                <div class="cn">区域决选第一轮</div>
                <div class="en">Round 1</div>
              </div>
              <div class="desc desc2">
                <div class="cn">{{ questionData.description }}</div>
                <div class="en word-break">{{ questionData.engDescription }}</div>
              </div>
              <div class="index-title" v-if="questionData.isStandby">备用题<span>{{ questionData.quizNumber }}</span></div>
              <div v-else>
                <div class="index-title" v-if="questionData.quizForm === 1">例题</div>
                <div class="index-title" v-if="questionData.quizForm === 0">第<span>{{ questionData.quizNumber }}</span>题</div>
              </div>
              <div class="stem-area">
                <div class="options">
                  <div class="option" :class="isImg ? 'option-img' : ''" v-for=" (item, i) in options" :key="i" >
                    <!-- @click="chooseFn(i)" -->
                    <div class="option-item" :class="item.choose ? 'choose' : ''">
                      <img :src="item.content" v-if="isImg"/>
                      <div v-else>{{ item.content }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <img class="logo" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/logo.png" alt="">
              <div class="redbar">REGIONAL FINAL</div>
              <div class="time-bg">
                <div>{{ quizTime }}s</div>
              </div>
            </div>
          </div>
          <img class="qr" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/right.jpg" alt="">
        </div>
      </div>
    </div>
    <!-- <div class="stu-inner-main">
      <div class="main-img">
        <img class="season2-logo1" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/spbcn-cebsb.png" alt="">
        <img class="season2-logo2" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/season4-logo1.png" alt="">
      </div>
       <img class="season2-logo3" src="https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/wzdlsj.png" alt="">
      <div class="oq-flex">
        <div class="main">
          <div class="cn-title">{{ questionData.description }}</div>
          <div class="en-title">{{ questionData.engDescription }}</div>
          <div class="index-title" v-if="questionData.quizForm === 1">例题</div>
          <div class="index-title" v-if="questionData.quizForm === 0">第<span>{{ questionData.quizNumber }}</span>题</div>
          <div class="options">
            <div class="option" :class="isImg ? 'option-img' : ''" v-for=" (item, i) in options" :key="i" @click="chooseFn(i)">
              <div class="option-item" :class="item.choose ? 'choose' : ''">
                <img :src="item.content" v-if="isImg"/>
                <div v-else>{{ item.content }}</div>
              </div>
            </div>
          </div>
          <div v-if="quizForm === 0">
            <div class="times" v-if="!clickable">本题倒计时：<span>{{quizTimeStr}}</span></div>
            <div class="times" v-if="clickable">请注意考试剩余时间：<span>{{leftTimeStr}}</span></div>
          </div>
        </div>
      </div>

    </div> -->

    <!-- 弹窗 -->

    <!-- 确认弹窗 -->
     <!-- <customConfirm v-if="showConfirm"
      :msg="msg"
      :enMsg="enMsg"
      :confirm="okText"
      :enConfirm="okEnText"
      :cancel="cancelText"
      :enCancel="cancelEnText"
      :isPhone="isPhone"
      @cancel="cancelFn()"
      @confirm="confirmFn()"></customConfirm> -->
  </div>
</template>
<script>
import env from '@/http/env'
export default {
  // components: {
  //   topBanner
  // },
  data () {
    return {
      districtId: '',
      activityType: this.$chnEngStatusCode.activityType,
      season: this.$route.query.season,
      raceSchedule: this.$route.query.rs,
      dialogVisible: false,
      dialogVisible2: false,
      desc: '',
      descEn: '',
      quizId: '',
      currentIndex: 0, // 记录当前正在作答的题目（getProgress接口返回的index）
      saveIndex: 0, // 记录保存的哪道题
      pageNum: 0,
      pageSize: 1,
      questionData: {},
      quizMode: 1, // 1单选 >1多选
      options: [], // 选项
      isImg: false, // 选项是否是图片
      correctAnswerList: [], // 正确答案
      quizForm: 0, // 0作答题目 1例题
      total: 0, // 题目总数量
      progressData: [],
      questionList: [], // 答题卡
      list: [
        { status: 0, title: '未完成', enTitle: 'Unanswered' },
        { status: 1, title: '已完成', enTitle: 'Answered' }
      ],
      showConfirm: false,
      msg: '',
      enMsg: '',
      lang: 'cn',
      clickable: false,
      formTimeStr: '',
      isLastOne: false, // 答到最后一题
      pageState: -1, // 记录页面状态，1超时交卷 2主动交卷有未完成题目 3点击例题开始答题
      okText: '',
      okEnText: '',
      cancelText: '',
      cancelEnText: '',
      quizTime: 0, // 每题时间 s，不从试卷设置里取，取接口formMatch/getProgress返回的endTime-now
      quizTimeStr: '', // 每题时间 00:59
      timer: null, // 每题倒计时计时器
      leftTime: 0, // 2分钟倒计时
      leftTimeStr: '',
      timer2: null,
      start2Minutes: false,
      base: env.baseWebIP,
      phone: false,
      quizTimer: null, // 请求接口定时器
      isPhone: false
    }
  },
  created () {
    // this.isPhone = window.screen.width < 500
    this.roomId = this.$route.query.roomId
    this.pageNum = 0
    this.saveIndex = 0
    // this.queryTheOnlineQuizForm()
    this.queryMatchStatus()
    this.quizTimer = setInterval(() => {
      this.queryMatchStatus()
    }, 3000)
  },
  beforeDestroy () {
    this.stopCountdown() // 每题倒计时
    this.stopCountdown2() // 2min倒计时
    this.stopTimer() // 轮询定时器
  },
  methods: {
    /**
     * 复赛答题说明：
     * 1、无主动提交按钮，每题时长获取后端返回的截止提交日期进行倒计时，每题倒计时结束后，自动提交。
     * 2、答题过程中，不可点击答题卡跳题
     * 3、答完全部题目后，倒计时120s（2分钟），倒计时结束后不提交，考生可主动提交，最后需统一点击erp的比赛结束提交试卷
     * 4、最后提交时，如有剩余时间，检查是否有未作答，如果有，弹窗提示
     */
    getPageTitle () {
      return this.$route.query.formName
    },

    // 获取试卷信息
    queryTheOnlineQuizForm () {
      this.$http.get(`${this.base}form/queryTheOnlineQuizForm?season=${this.season}&raceSchedule=${this.raceSchedule}&activityType=${this.activityType}`).then(res => {
        if (res.code === 200) {
          this.desc = res.data.formExplain
          this.descEn = res.data.questionExplain
          this.quizId = res.data.id
          // this.quizTime = Math.floor((res.data.formTime - 120) / 25) // 向上取整
          // this.getQusetionData()

          // 开始轮询题号
          this.queryMatchStatus()
          this.quizTimer = setInterval(() => {
            this.queryMatchStatus()
          }, 1000)
        }
      })
    },

    // 两题间过渡提示
    transitionTips () {
      this.msg = '本题已作答完成，请等待。'
      this.enMsg = 'Answer submitted. Please wait.'
      this.okText = ''
      this.okEnText = ''
      this.cancelText = ''
      this.cancelEnText = ''
      // this.showConfirm = true
    },

    /**
     * 轮询
     * 1、返回的参数index是this.pageNum，判断index !== this.pageNum,进入下一题
     * 2、返回的endTime是截止提交时间，用endTime - now开始倒计时，倒计时结束后，提交答案，显示已提交弹窗
     * 3、如果倒计时未结束，裁判点击进入了下一题，要提交本题答案，每次进入下一题需判断答案是否提交
     */

    queryMatchStatus () {
      this.$http.get('examinationUser/getProgress?id=' + this.roomId, { showLoading: false }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            if (res.data.matchEndType === 2) {
              // 结束
              // this.saveAnswer(4)
              // this.savePaper()
            } else if (res.data.questionId) {
              if (!this.clickable) {
                this.endTime = res.data.endTime
                this.currentIndex = res.data.index
                // 进入下一题
                if (Number(res.data.index) !== Number(this.pageNum)) {
                  if (this.saveIndex !== this.pageNum) { // 判断当前题目是否保存。
                    this.saveIndex = this.pageNum
                    // this.nextFn()
                  }
                  this.pageNum = res.data.index
                  this.getQusetionData()
                }
              }
            }
          }
        }
      })
    },
    stopTimer () {
      clearInterval(this.quizTimer)
      this.quizTimer = null
    },

    // 获取题目信息
    getQusetionData () {
      this.$http.get('examinationUser/queryTheOnlineQuizFormListPage', {
        showLoading: false,
        params: {
          // season: this.season,
          // raceSchedule: this.raceSchedule,
          // activityType: this.activityType,
          // quizId: this.quizId,
          id: this.roomId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.isLastOne = this.pageNum === this.total
          this.questionData = res.data.list[0]
          this.quizForm = Number(this.questionData.quizForm)
          this.options = this.questionData.choice.split(',').map(item => {
            return { choose: false, content: item }
          })
          this.isImg = this.questionData.choice.includes('http')
          this.correctAnswerList = this.questionData.answer.split(',')
          this.showConfirm = false
          if (this.quizForm === 1) {
            // 例题默认选中
            this.options.forEach(item => {
              this.correctAnswerList.forEach(ans => {
                if (item.content === ans) {
                  item.choose = true
                }
              })
            })
          } else {
            // this.queryTheProgressBar()
            // this.queryFormAnswer(res.data.list[0])

            this.quizTime = Math.floor((this.endTime - new Date().getTime()) / 1000)
            if (this.quizTime > 0) {
              this.quizTimeStr = this.$xcUtils.sec2time(this.quizTime)
              this.startCountDown()
            } else {
              if (this.isLastOne) {
                this.clickable = true
                const leftTime = Math.floor((this.endTime + 2 * 60 * 1000 - new Date().getTime()) / 1000)
                this.start2Minutes = true
                if (leftTime > 0) {
                  this.startCountDown2(leftTime)
                } else {
                  this.leftTimeStr = '00:00'
                }
              } else {
                this.quizTimeStr = '00:00'
                this.transitionTips()
              }
            }
          }
        }
      })
    },
    // 获取进度条
    queryTheProgressBar () {
      this.$http.post(this.base + 'form/queryTheProgressBar', {
        quizId: this.quizId,
        season: this.season,
        activityType: this.activityType,
        raceSchedule: this.raceSchedule
      }, { showLoading: false }).then(res => {
        if (res.code === 200) {
          const list = res.data
          const flags = ['A', 'B', 'C', 'D', 'E']
          list.forEach((item, index) => {
            item.totalPercent = (item.quizNum / this.total) * 100 // 题型宽度占比
            item.percent = (item.answerNum / item.quizNum) * 100 // 答题进度
            item.flag = flags[index]
          })
          this.progressData = list
          console.log(list)
        }
      })
    },
    // 查询此题目是否做过，做过的回显答案
    queryFormAnswer (question) {
      if (!question.quizNumber) return // 例题不请求
      const data = {
        season: this.season,
        raceSchedule: this.raceSchedule,
        activityType: this.activityType,
        quizId: this.quizId,
        formQuizId: question.formQuizId || question.id,
        quizNumber: question.quizNumber,
        quizSequence: question.quizSequence
      }
      this.$http.post(this.base + 'form/queryTheOnlineFormAnswer', data, { showLoading: false }).then(res => {
        if (res.code === 200) {
          const questionData = res.data.list[0]
          const optionArr = questionData.choice.split(',').map(opt => {
            return {
              content: opt,
              choose: false
            }
          })
          this.quizMode = questionData.answer.split(',').length
          if (questionData.userAnswer) {
            const userAnswerArr = questionData.userAnswer.split(',')
            optionArr.forEach(opt => {
              userAnswerArr.forEach(ans => {
                if (ans === opt.content) {
                  opt.choose = true
                }
              })
            })
          }
          this.$set(this, 'options', optionArr)
          if (this.clickable) {
            this.dialogVisible2 = false
            this.isImg = questionData.choice.includes('http')
            this.questionData = questionData
          }
          this.pageNum = res.data.pageNum
        }
      })
    },
    // 开始倒计时
    startCountDown () {
      this.stopCountdown()
      // console.log('倒计时开始')
      let quizTime = this.quizTime
      this.timer = setInterval(() => {
        quizTime--
        if (quizTime > 0) {
          this.quizTimeStr = this.$xcUtils.sec2time(quizTime)
          this.quizTime = quizTime
          console.log(this.quizTime)
        } else {
          this.saveIndex = this.pageNum
          this.quizTimeStr = '00:00'
          this.stopCountdown()
        }
        // console.log(quizTime, this.quizTimeStr)
      }, 1000)
    },
    // 停止倒计时
    stopCountdown () {
      clearInterval(this.timer)
      this.timer = null
    },
    // 答题结束后，2分钟倒计时
    startCountDown2 (leftTime) {
      this.stopCountdown2()
      console.log('倒计时开始')
      this.timer2 = setInterval(() => {
        leftTime--
        if (leftTime > 0) {
          this.leftTimeStr = this.$xcUtils.sec2time(leftTime)
        } else {
          this.leftTimeStr = '00:00'
          this.stopCountdown2()
          // 时间到，主动交卷 ==》改为不主动交卷
          // this.savePaper()
        }
      }, 1000)
    },
    stopCountdown2 () {
      clearInterval(this.timer2)
      this.timer2 = null
    },

    chooseFn (index) {
      if (this.quizForm === 1) return
      console.log(this.questionData)
      // quizMode 1 单选 >1多选
      console.log(this.quizMode)
      if (this.quizMode === 1) {
        this.options.forEach(item => {
          item.choose = false
        })
        this.options[index].choose = true
      } else {
        this.options[index].choose = !this.options[index].choose
      }
      console.log(this.questionData)
    },
    // 点击例题开始答题
    startExam () {
      console.log(this.pageNum)
      if (this.pageNum === 1) {
        this.msg = '请在裁判席给出明确指令后，再点击“确认”开始答题倒计时。'
        this.enMsg = 'Please wait for the judges to give clearinstructions before clicking “Confrm” to start the countdown timer.'
        this.okText = '确认'
        this.okEnText = 'Confirm'
        this.cancelText = '取消'
        this.cancelEnText = 'Cancel'
        this.showConfirm = true
        this.pageState = 3
      } else {
        this.nextQuestion()
      }
    },
    nextQuestion () {
      // this.pageNum = this.pageNum + 1
      this.getQusetionData()
    },
    confirmFn () {
      // if (this.pageState === 3) {
      //   this.getNextPageInfo()
      // } else if (this.pageState === 2) {
      //   this.savePaper()
      // }
    },
    cancelFn () {
      this.showConfirm = false
      if (this.pageState === 2) {
        this.showAnswerList()
      }
    },
    getNextPageInfo () {
      this.showConfirm = false
      // 获取正式题目信息: 题目、进度条、
      this.nextQuestion()
      this.queryTheProgressBar()
    },
    nextFn () {
      // this.saveAnswer(1)
    },
    submit () {
      // this.saveAnswer(2)
    },
    save () {
      // this.saveAnswer(3)
    },
    /**
     * 保存本题答案
     * @param type 1点下一题 2点交卷 3点保存 4裁判系统点本场比赛结束
     */
    saveAnswer (type) {
      const userAnswer = this.options.filter(item => item.choose).map(item => item.content).join(',')
      console.log(userAnswer)
      const data = {
        activityType: this.activityType,
        raceSchedule: this.raceSchedule,
        season: this.season,
        quizId: this.quizId,
        quizInfoId: this.questionData.id,
        userAnswer
      }
      this.$http.post(this.base + 'form/saveTheOnlineFormAnswer', data).then(res => {
        if (res.code === 200) {
          if (type === 1) {
            // 每题之间只保存答案并弹窗本题已答完，不切换下一题
            if (this.quizTimeStr === '00:00') { // 倒计时耗尽展示过渡弹窗，倒计时未耗尽裁判强制提交，不展示过渡弹窗直接进入下一题
              this.transitionTips()
            }
            // this.nextQuestion()
            this.queryTheProgressBar()
          } else if (type === 2) {
            // 超时交卷直接提交（==改为超时不强制交卷，裁判点提交）
            // if (this.pageState === 1) {
            //   // this.savePaper()
            // } else {
            //   // 获取进度条
            //   this.queryTheProgressBar()
            //   // 主动交卷，查询是否有未完成的题目
            //   this.checkPaper(1)
            // }
            // 获取进度条
            this.queryTheProgressBar()
            // 主动交卷，查询是否有未完成的题目
            this.checkPaper(1)
          } else if (type === 3) {
            this.$message.success('已保存')
            // 答题卡查看题目，只保存答案
            this.queryTheProgressBar()
          } else if (type === 4) {
            this.queryTheProgressBar()
            setTimeout(() => {
              this.savePaper()
            }, 500)
          }
          console.log(this.currentIndex, this.isLastOne, this.saveIndex)
          if (this.isLastOne && this.saveIndex === this.currentIndex) {
            this.clickable = true
          }
        }
      })
    },
    // 检查是否有未完成试题
    // type 1-点击试卷右下角的交卷（弹出答题卡确认） else答题卡上的交卷（全部作答的直接交卷）
    checkPaper (type) {
      this.$http.get(this.base + 'form/queryWhetherUnfinishedQuestions', {
        params: {
          activityType: this.activityType,
          raceSchedule: this.raceSchedule,
          season: this.season,
          quizId: this.quizId
        }
      }).then(res => {
        if (res.code === 200) {
          if (!this.start2Minutes) {
            // 开始120s倒计时
            this.start2Minutes = true
            this.leftTimeStr = this.$xcUtils.sec2time(120)
            this.startCountDown2(120)
          }
          // 已完成全部作答1
          // 有未完成作答题目2
          if (res.data === 2) {
            // 有：弹窗提示
            this.pageState = 2
            this.msg = '还有题目尚未完成。'
            this.enMsg = 'Unfinished.'
            this.okText = '交卷'
            this.okEnText = 'Submit'
            this.cancelText = '返回答题'
            this.cancelEnText = 'Back'
            this.showConfirm = true
          } else {
            // 无：弹出答题卡，答题卡按钮显示为【交卷】
            if (type === 1) {
              this.showAnswerList()
            } else {
              this.savePaper()
            }
          }
        }
      })
    },
    savePaper () {
      const data = {
        activityType: this.activityType,
        raceSchedule: this.raceSchedule,
        season: this.season,
        quizId: this.quizId
      }
      this.$http.post(this.base + 'form/saveQuizMatchAnswer', data).then(res => {
        if (res.code === 200) {
          if (this.pageState === 1) {
            // 超时交卷提示
            this.msg = '考试结束，试卷已提交。'
            this.enMsg = 'The exam is over and the answers have been submitted..'
            this.okText = '确定'
            this.okEnText = 'OK'
            this.cancelText = ''
            this.showConfirm = true
          } else {
            // 主动交卷直接弹出完成
            this.$router.push(`/padSemiResult?formName=${this.$route.query.formName}`)
          }
          this.stopCountdown2()
        }
      })
    },
    // 查看答题卡
    showAnswerList () {
      if (this.clickable) {
        this.save()
      }
      this.$http.post(this.base + 'form/queryQuizMatchAnswer', {
        quizId: this.quizId,
        season: this.season,
        activityType: this.activityType,
        raceSchedule: this.raceSchedule
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible2 = true
          this.questionList = res.data
        }
      })
    },
    // 点击答题卡题号跳转
    quizNumberTap (question) {
      if (this.clickable) {
        this.queryFormAnswer(question)
      }
    },
    onClose () {
      this.dialogVisible2 = false
    },
    toFull () {
      this.$xcUtils.toFull()
    }
    // handleToIndex () {
    //   this.$router.push('/stu/index')
    // }
  }
}
</script>
<style scoped lang="less">
.oq-flex{
  // display: flex;
  width: 90%;
  margin: 20px auto 0;
  .left{
    text-align: center;
    margin-right: 30px;
    .dtsm-btn{
      color: #fff;
      height: 20px;
      line-height: 20px;
      background-color: #f9bd1a;
      border-radius: 20px;
      text-align: center;
      width: 80px;
      cursor: pointer;
      margin-bottom: 10px;
      font-size: 12px;
    }
    .play{
      width: 40px;
    }
  }
}
.main{
  margin: 20px auto;
  background-color: rgba(255, 255, 0, .3);
  width: 70%;
  border-radius: 20px;
  padding: 20px;
}
.cn-title{
  color: #000;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}
.en-title, .desc-t{
  color: #000;
  font-size: 12px;
  margin-bottom: 4px;
}
.index-title{
  color: #000;
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
  span{
    font-size: 32px;
    font-weight: bold;
    margin: 0 4px;
    color: #B81c25;
  }
}
.options{
  // display: flex;
  // align-items: center;
  // justify-content: center;
  margin-top: 20px;
  text-align: center;
  .option{
    display: inline-block;
    width: 180px;
    height: 92px;
    line-height: 92px;
    background-color: #fff;
    color: #000;
    border-radius: 22px;
    text-align: center;
    cursor: pointer;
    box-shadow: 0px 4px 10px 4px rgba(0, 0, 0, .05);
    margin: 10px;
    font-size: 50px;
    font-weight: bold;
     .choose{
      color: #fff;
      background-color: #f9bd1a;
      width: 100%;
      height: 100%;
      border-radius: 22px;
    }
    &.option-img{
      width: 180px;
      height: 158px;
      line-height: 58px;
    }
    img{
      height: 100px;
      width: auto;
    }
    .option-item{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.times{
  text-align: center;
  font-size: 16px;
  color: #000;
  font-weight: bold;
  margin-top: 40px;
  span{
    color: #b81c25;
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  .btn{
    margin: 40px;
    width: 140px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-radius: 40px;
    cursor: pointer;
    &:active{
      box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.5);
    }
    &.btn1{
      background-color: #352b28;
    }
    &.btn2{
      background-color: #B81c25;
    }
  }
}
.progress{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin: 40px auto 0;
  .progress-item{
    height: 18px;
    line-height: 18px;
    border: 1px solid #f9bd1a;
    position: relative;
    border-radius: 10px;
    margin: 4px;
    text-align: center;
    color: #ca6903;
    font-size: 12px;
    background-color: rgba(255, 255, 255, .3);
    .index{
      color: #ca6903;
      position: absolute;
      left: 4px;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 10;
      width: 16px;
      font-size: 12px;
      text-align: center;
      line-height: 18px;
    }
    .inner{
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background: #f9bd1b;
      border-radius: inherit;
    }
    span{
      position: relative;
      z-index: 100;
    }
  }
}
.page-title{
  font-size: 24px;
  font-family: regular;
  text-align: center;
  color: #000;
  margin-top: 10px;
  margin-bottom: 60px;
  position: relative;
  &::after{
    display: block;
    content: '';
    width: 100px;
    height: 2px;
    background-color: #b81c25;
    margin: 4px auto 20px;
  }
  .lang{
    position: absolute;
    right: 40px;
    top: 40px;
    display: flex;
    align-items: center;
    div{
      width: 50px;
      height: 20px;
      margin: 0 4px;
      border-radius: 20px;
      background-color: #000;
      color: #fff;
      text-align: center;
      line-height: 20px;
      font-size: 14px;
      font-family: normal;
    }
    .choose{
      background-color: #B81c25;
    }
  }
}
.page-title1{
  margin-bottom: 0;
}
.desc{
  font-size: 14px;
  color: #000;
  line-height: 28px;
  white-space: pre-line;
  padding-bottom: 40px;
  padding-left: 60px;
  padding-right: 60px;
  min-height: 200px;
}
.dialog-bg{
  background-image: url(../../../assets/img/stu-page-bg.png);
  background-size: 100% auto;
  background-position: left bottom;
  background-repeat: no-repeat;
  .desc{
    background-color: rgba(255,255,255,0.5);
  }
}
/deep/ .el-dialog__body{
  padding: 0;
}

// 答题卡样式
.clickable-tip{
  padding: 12px;
  text-align: center;
  font-family: regular;
  font-size: 18px;
  color: #221714;
}
.flag{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flag-item{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 18px;
  }
  .flag-blank{
    width: 30px;
    height: 30px;
    border-radius: 6px;
    margin-right: 8px;
    border: 1px solid;
    border-bottom-width: 4px;
  }
  .flag-item0 .flag-blank{
    border-color: #221714;
    border-bottom-color: #221714;
    background-color: #dfdfdf;
  }
  .flag-item2 .flag-blank{
    border-color:#ec525b;
    border-bottom-color: #b81c25;
    background-color: #ec525b;
  }
  .flag-item1 .flag-blank{
      border-color: #f8bc1c;
      border-bottom-color: #b8701d;
    background-color: #f8bc1c;
  }
  .flag-title{
    font-family: regular;
    font-size: 18px;
    line-height: 26px;
  }
  .flag-title-en{
    font-family: regular;
    font-size: 14px;
    color: #A48C4E;
  }
  .van-popup-content{
    overflow-y: auto;
  }
  .part{
    padding-top: 20px;
  }
  .part-title{
    font-size: 18px;
    font-family: regular;
    color: #000;
    font-weight: 500;
    padding: 0 30px;
    display: flex;
    align-items: center;
  }
  .part-title::before{
      content: "";
      display: inline-block;
      width: 3px;
      height: 20px;
      margin-right: 10px;
      background-color: #ecae32;
  }
  .part-title span{
    color: #BB1C25;
  }
  .ques-btn{
    width: 96px;
    height: 96px;
    text-align: center;
    line-height: 96px;
    border-radius: 30px;
    background-color: #e7e6e4;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    margin: 14px;
    float: left;
  }
  .part-ques{
    overflow: hidden;
    padding: 10px 36px;
  }
  .ques-btn1{
    background-color: #f15151;
  }
  .ques-btn2{
    background-color: #f8aa00;
  }
  .question-blank{
    width: 40px;
    height: 40px;
    border-radius: 6px;
    text-align: center;
    line-height: 40px;
    font-size: 24px;
    font-family: hzgb;
    color: #fff;
    margin: 4px;
    float: left;
    border: 1px solid;
    border-bottom-width: 3px;
  }
  .questions{
    overflow: hidden;
  }
  .question-status0{
      border-color: #221714;
      border-bottom-color: #221714;
      background-color: #dfdfdf;
      color: #221714;
  }
  .question-status2{
      border-color:#ec525b;
      border-bottom-color: #b81c25;
      background-color: #ec525b;
  }
  .question-status1{
      border-color: #f8bc1c;
      border-bottom-color: #b8701d;
      background-color: #f8bc1c;
  }
  ::v-deep .el-dialog__header{
    padding: 16px 0 0;
  }
  ::v-deep .el-dialog__headerbtn{
    z-index: 100;
  }
  .countdown{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    .time{
      color: #B81c25;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .pop-footer{
    padding-top: 20px;
    padding-bottom: 40px;
  }
  .pop-footer-btn{
    background-color: #B81c25;
    margin: 10px auto 0;
    border-radius: 42px;
    font-size: 16px;
    color: #fff;
    height: 42px;
    line-height: 42px;
    text-align: center;
    width: 240px;
    &:active{
      box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.5);
    }
  }
  .stu-inner-main{
    width: 100vw;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #d8d8d8;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/season4bg.jpg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .top-banner{
    width: 100%;
    height: 150px;
    background-image: url(../../../assets/img/top-bg.png);
    background-size: cover;
    background-position: center;
    text-align: center;
    line-height: 150px;
    font-size: 30px;
    font-family: regular;
    color: #fff;
    margin-bottom: 20px;
  }
  .fullScreen{
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 30px;
    height: 30px;
  }
  *{
    -webkit-tap-highlight-color: transparent;
  }

@media screen and (max-width: 500px) {
  /* 在这里应用适合小屏幕设备的样式 */
  .options{
    overflow: hidden;
    display: block;
  }
  .options .option{
    float: left;
    width: 40%;
  }
}

.main-img{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  .season2-logo1{
    height: 48px;
  }
  .season2-logo2{
    height: 44px;
  }
}
.season2-logo3{
  position: absolute;
  right: 40px;
  bottom: 40px;
  height: 60px;
}
.container{
  width: 100vw;
  height: 100vh;
  position: relative;
  .div-left{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 50%;
    background-color: #FFF;
  }
}
.season1{
  background-color: #B81C25;
}
.screen{
  // width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  color: #000;
  font-family: 'regular';
  margin: 0 auto;

  .right-bg{
    width: 50%;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #b81c25;
    z-index: -1;
  }
}
.page{
  // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.content{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  overflow: hidden;
}

  .left{
    width: 50%;
    height: 100%;

    .title{
      margin: 50px auto 40px;
      width: 100%;
      height: 100px;
      padding-top: 10px;
      box-sizing: border-box;
      // line-height: 64px;
      text-align: center;
      background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_title_bg.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 100%;
      color: #fff;
      .cn{
        font-size: 32px;
      }
      .en{
        font-size: 26px;
      }
    }
  .desc{
    &.desc2{
      margin-left: 40px;
      margin-top: 40px;
      line-height: 30px;
      padding-bottom: 10px;
      .cn{
        font-size: 20px;
        margin-bottom: 10px;
      }
      .en{
        font-size: 18px;
      }
    }
  }
}
.right{
  width: 50%;
  height: 100%;
  position: relative;
  .logo{
    height: 280px;
    position: absolute;
    right: 40px;
    top: 42px;
  }
  .time-bg{
    width: 840px;
    height: 840px;
    margin: 130px auto 0;
    box-sizing: border-box;
    padding-bottom: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_time_bg_1.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 90%;
    font-size: 160px;
    div{
      height: 200px;
      line-height: 200px;
    }
  }
}
.fullscreen{
  width: 32px;
  height: 32px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  cursor: pointer;
}
.fullscreen-top{
  width: 32px;
  height: 32px;
  position: fixed;
  left: 10px;
  top: 10px;
  cursor: pointer;
}
.refresh{
  left: 50px !important;
}
.stem-area{
  width: 460px;
  min-height: 460px;
  margin: 0 auto;
}

.type1{
  .block{
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 54px;
    background-color: #fbb201;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
    border-radius: 16px;
    margin-bottom: 16px;
  }
}
.type2{
  position: relative;
  .block{
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 54px;
    background-color: #f96950;
    box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
    border-radius: 16px;
    margin-bottom: 16px;
    position: absolute;
    &.block0{ top: 0; left: 0; }
    &.block1{ top: 0; left: 116px; }
    &.block2{ top: 0; left: 232px; }
    &.block3{ top: 0; left: 348px; }
    &.block4{ top: 116px; left: 0; }
    &.block5{ top: 116px; left: 348px; }
    &.block6{ top: 232px; left: 0; }
    &.block7{ top: 232px; left: 348px; }
    &.block8{ top: 348px; left: 0; }
    &.block9{ top: 348px; left: 116px; }
    &.block10{ top: 348px; left: 232px; }
    &.block11{ top: 348px; left: 348px; }
  }
  .center{
    width: 218px;
    height: 218px;
    position: absolute;
    top: 116px;
    left: 116px;
    border-radius: 36px;
    font-size: 140px;
  }
}
.type3{
  .block{
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border: 4px solid #b81c25;
    border-radius: 20px;
    margin-bottom: 10px;
    img{
      height: 98%;
      border-radius: 20px;
    }
  }
  .area2{
    width: 340px;
    margin: 0 auto;
    .block2{
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'fzcsk';
      font-size: 54px;
      background-color: #e5e5e5;
      box-shadow: inset 2px 2px 15px rgba(0,0,0,0.4);
      border-radius: 20px;
      margin-bottom: 14px;
    }
  }
}
.progress2{
  margin: 20px auto 0;
  width: 680px;
  height: 80px;
  display: flex;
  align-items: center;
  background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 20px;
  .progress-item{
    flex: 1;
    height: 60px;
    line-height: 54px;
    font-size: 42px;
    color: #FFF;
    text-align: center;
    margin: 3px;
    background-color: #ababab;
    border-radius: 16px;
  }
  .quizIngCount{
    background-color: #066e84;
  }
  .done{
    background-color: #A50400;
  }
}
.progress1{
  margin: 120px auto 0;
  width: 600px;
  height: 100px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  .progress-item{
    width: 130px;
    height: 130px;
    color: #fff;
    font-size: 76px;
    text-align: center;
    padding-top: 10px;
    box-sizing: border-box;
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_icon3.png);
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_icon4.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    margin: 6px;
  }
  .quizIngCount{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_icon2.png);
  }
  .done{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_schedule_icon1.png);
  }
}

.season1 {
  .page{
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/cebsb_screen_bg.png);
  }
}
.season2 {
  .page{
    // background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season2/season2bg.png);
    background-image: url(https://cdn.spbcn.org/chineseWord/applets/images/final_pad/season4/season4bg.jpg);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .qr{
    height: 100%;
    width: auto;
  }
  .content{
    flex: 1;
  }
  .left{
    // background: rgba(255, 248, 225, .7);
    background: rgba(250, 250, 243, .7);

    // 九宫格游戏时不设置背景颜色
    &.nine-grid-game {
      background: transparent !important;
    }
  }
  .logo{
    width: 500px;
    height: auto;
    top: 100px;
  }
  .redbar{
    position: absolute;
    right: 190px;
    top: 260px;
    color: #fff;
    background: #b81c25;
    font-size: 28px;
    padding: 0 40px;
    height: 38px;
    line-height: 32px;
  }
  .type2 .block{
    background-color: #fff8e1;
    box-shadow: none;
    border: 2px solid #000;
    box-sizing: border-box;
  }
  .type1 .block{
    background-color: #fff8e1;
    box-shadow: none;
    border: 2px solid #000;
    box-sizing: border-box;
  }
  .type3{
    .area2{
      .block2{
        background-color: #fff8e1;
        box-shadow: none;
        border: 2px solid #000;
        box-sizing: border-box;
      }
    }
  }
  .type4{
    position: relative;
    .choice-pic{
      width: 150px;
      height: 150px;
      position: absolute;
      top: -200px;
      // right: -150px;
      right: -194px;
      border: 4px solid #951414;
      border-radius: 20px;
    }
    .grid-container {
      display: flex;
      gap: 40px;
      align-items: flex-start;
      justify-content: center;
      margin-left: 100px;
      margin-top: 30px;
      width: 100%;
      max-width: 800px;
      flex-wrap: nowrap;

      @media (max-width: 720px) {
        gap: 10px;
        justify-content: space-between;
        max-width: 100%;
      }

      @media (min-width: 721px) and (max-width: 1023px) {
        gap: 20px;
      }

      @media (max-width: 480px) {
        gap: 8px;
      }

      @media (max-width: 320px) {
        gap: 5px;
      }
    }

    .left-grid-wrapper,
    .right-grid-wrapper {
      border: 3px solid #b81c25;
      border-radius: 20px;
      padding: 20px;
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(5px);
      box-shadow: 0 4px 15px rgba(184, 28, 37, 0.2);
      // flex: 1;
      // min-width: 0;

      @media (max-width: 720px) {
        padding: 8px;
        border-radius: 10px;
        border-width: 2px;
      }

      @media (min-width: 721px) and (max-width: 1023px) {
        padding: 15px;
        border-radius: 16px;
      }

      @media (max-width: 480px) {
        padding: 6px;
        border-radius: 8px;
        border-width: 1px;
      }

      @media (max-width: 320px) {
        padding: 4px;
        border-radius: 6px;
      }
    }

    .left-grid-wrapper {
      border-color: #b81c25;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, #b81c25, #ff6b6b);
        border-radius: 22px;
        z-index: -1;
        opacity: 0.3;

        @media (max-width: 720px) {
          border-radius: 17px;
        }
      }
    }

    .right-grid-wrapper {
      border-color: #409eff;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, #409eff, #67c23a);
        border-radius: 22px;
        z-index: -1;
        opacity: 0.3;

        @media (max-width: 720px) {
          border-radius: 17px;
        }
      }
    }

    .grid-title {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
      padding: 8px 0;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 10px;
      border: 1px solid rgba(0, 0, 0, 0.1);

      @media (max-width: 720px) {
        font-size: 12px;
        margin-bottom: 6px;
        padding: 3px 0;
      }

      @media (min-width: 721px) and (max-width: 1023px) {
        font-size: 16px;
        margin-bottom: 12px;
      }

      @media (max-width: 480px) {
        font-size: 10px;
        margin-bottom: 4px;
        padding: 2px 0;
      }

      @media (max-width: 320px) {
        font-size: 9px;
        margin-bottom: 3px;
        padding: 1px 0;
      }
    }

    .area2 {
      width: 262px;
      margin-left: 0;
      .block2 {
        width: 76px;
        height: 76px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        box-sizing: border-box;
        font-family: 'fzcsk';
        font-size: 36px;
        background-color: #e5e5e5;
        box-shadow: inset 2px 2px 15px rgba(0, 0, 0, 0.4);
        border: 2px solid #000;
        border-radius: 14px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: all 0.2s ease;

        &.active {
          border-color: #b81c25;
          background-color: #ffb700;
          transform: scale(1.05);
        }

        &:hover {
          transform: scale(1.02);
        }

        @media (max-width: 650px) {
          width: 40px;
          height: 40px;
          font-size: 16px;
          border-radius: 6px;
          margin-bottom: 4px;
        }

        @media (max-width: 480px) {
          width: 32px;
          height: 32px;
          font-size: 14px;
          border-radius: 5px;
          margin-bottom: 3px;
        }

        @media (max-width: 320px) {
          width: 28px;
          height: 28px;
          font-size: 12px;
          border-radius: 4px;
          margin-bottom: 2px;
        }

        @media (min-width: 651px) and (max-width: 1023px) {
          width: 55px;
          height: 55px;
          font-size: 24px;
          border-radius: 10px;
          margin-bottom: 6px;
        }

        @media (min-width: 1024px) and (max-width: 1439px) {
          width: 68px;
          height: 68px;
          font-size: 30px;
          border-radius: 12px;
          margin-bottom: 8px;
        }

        @media (min-width: 1440px) {
          width: 85px;
          height: 85px;
          font-size: 40px;
          border-radius: 15px;
          margin-bottom: 12px;
        }
      }
    }
  }
}

// 小组赛适配5.5米*2.5米大屏
.season2.group1{
  .logo{
    width: 250px;
    top: 50px;
  }
  .left {
    .title{
      margin: 40px auto 20px;
      height: 60px;
      padding-top: 8px;
      .cn{
        font-size: 18px;
      }
      .en{
        font-size: 16px;
      }
    }
    .desc.desc1{
      line-height: 28px;
      margin-top: 30px;
      .cn{
        font-size: 18px;
        margin-bottom: 10px;
      }
      .en{
        font-size: 16px;
      }
    }
  }
  .progress1{
    margin-top: 50px;
    width: 100%;
    .progress-item{
      width: 100px;
      height: 100px;
      padding-top: 0;
      line-height: 84px;
    }
  }
  .redbar{
    top: 130px;
    font-size: 22px;
    padding: 0 20px;
    height: 28px;
    line-height: 22px;
  }
  .right{
    .time-bg{
      width: 580px;
      height: 540px;
      margin-top: 66px;
      font-size: 134px;
      div{
        height: 180px;
      }
    }
  }
}

// 适配电视
.season2.TV {
  .qr{
    display: none;
  }
  .redbar{
    right: 200px;
  }
  .left .desc.desc2 {
    line-height: 36px;
    margin-bottom: 40px;
    .cn{
      font-size: 26px;
    }
    .en{
      font-size: 22px;
    }
  }
}
</style>
